import MessageConst from '@/shared/message-const';
import { TableFilters } from "@/components/common/common-table-filter.component";
import { DataOptions } from "vuetify";
import SystemConst from "./system-const";
import { FilterApiValue } from "./type";

/**
 * 共通関数定義
 */
export default class CommonFunction {
    // ひらがな(小文字付き)
    private static hiraganaLowerList = [
        'きゃ', 'きぃ', 'きゅ', 'きぇ', 'きょ',
        'ぎゃ', 'ぎぃ', 'ぎゅ', 'ぎぇ', 'ぎょ',
        'くぁ', 'くぃ', 'くぅ', 'くぇ', 'くぉ',
        'ぐぁ', 'ぐぃ', 'ぐぅ', 'ぐぇ', 'ぐぉ',
        'しゃ', 'しぃ', 'しゅ', 'しぇ', 'しょ',
        'じゃ', 'じぃ', 'じゅ', 'じぇ', 'じょ',
        'ちゃ', 'ちぃ', 'ちゅ', 'ちぇ', 'ちょ',
        'ぢゃ', 'ぢぃ', 'ぢゅ', 'ぢぇ', 'ぢょ',
        'つぁ', 'つぃ', 'つぇ', 'つぉ',
        'てゃ', 'てぃ', 'てゅ', 'てぇ', 'てょ',
        'でゃ', 'でぃ', 'でぅ', 'でぇ', 'でょ',
        'とぁ', 'とぃ', 'とぅ', 'とぇ', 'とぉ',
        'にゃ', 'にぃ', 'にゅ', 'にぇ', 'にょ',
        'ひゃ', 'ひぃ', 'ひゅ', 'ひぇ', 'ひょ',
        'ふぁ', 'ふぃ', 'ふぇ', 'ふぉ',
        'ふゃ', 'ふゅ', 'ふょ',
        'びゃ', 'びぃ', 'びゅ', 'びぇ', 'びょ',
        'ヴゃ', 'ヴぃ', 'ヴゅ', 'ヴぇ', 'ヴょ',
        'ぴゃ', 'ぴぃ', 'ぴゅ', 'ぴぇ', 'ぴょ',
        'みゃ', 'みぃ', 'みゅ', 'みぇ', 'みょ',
        'りゃ', 'りぃ', 'りゅ', 'りぇ', 'りょ',
        'うぃ', 'うぇ', 'いぇ', 'うぉ'
    ];
    // ローマ字（小文字付き）
    private static englishCharsLowerList = [
        'kya', 'kyi', 'kyu', 'kye', 'kyo',
        'gya', 'gyi', 'gyu', 'gye', 'gyo',
        'qwa', 'qwi', 'qwu', 'qwe', 'qwo',
        'gwa', 'gwi', 'gwu', 'gwe', 'gwo',
        'sha', 'syi', 'shu', 'shie', 'sho',
        'ja', 'jyi', 'ju', 'jie', 'jo',
        'cha', 'cyi', 'chu', 'chie', 'cho',
        'dya', 'dei', 'deyu', 'dye', 'dyo',
        'tsa', 'tsi', 'tse', 'tso',
        'tha', 'tei', 'thu', 'the', 'tho',
        'dha', 'di', 'dhu', 'dhe', 'dho',
        'twa', 'twi', 'twu', 'twe', 'two',
        'nya', 'nii', 'nyu', 'nye', 'nyo',
        'hya', 'hyi', 'hyu', 'hye', 'hyo',
        'fua', 'fui', 'fue', 'fuo',
        'fya', 'fyu', 'fyo',
        'bya', 'byi', 'byu', 'bye', 'byo',
        'vya', 'vyi', 'vyu', 'vye', 'vyo',
        'pya', 'pyi', 'pyu', 'pye', 'pyo',
        'mya', 'myi', 'myu', 'mye', 'myo',
        'rya', 'ryi', 'ryu', 'rye', 'ryo',
        'ui', 'ue', 'ye', 'uo'
    ];

    // ひらがな（小文字のみ）
    private static onlyLowerList = [
        'ぁ', 'ぃ', 'ぅ', 'ぇ', 'ぉ',
        'ゃ', 'ゅ', 'ょ', 'ゎ', 'っ'
    ];
    // ローマ字（小文字のみ）
    private static englishOnlyLowerList = [
        'a', 'i', 'u', 'e', 'o',
        'xya', 'xyu', 'xyo', 'xwa', 'xtu'
    ]

    // ひらがな
    private static hiraganaList = [
        'あ', 'い', 'う', 'え', 'お',
        'か', 'き', 'く', 'け', 'こ',
        'さ', 'し', 'す', 'せ', 'そ',
        'た', 'ち', 'つ', 'て', 'と',
        'な', 'に', 'ぬ', 'ね', 'の',
        'は', 'ひ', 'ふ', 'へ', 'ほ',
        'ま', 'み', 'む', 'め', 'も',
        'や', 'ゆ', 'よ', 'ー',
        'ら', 'り', 'る', 'れ', 'ろ',
        'わ', 'ゐ', 'ゑ', 'を', 'ん',
        'が', 'ぎ', 'ぐ', 'げ', 'ご',
        'ざ', 'じ', 'ず', 'ぜ', 'ぞ',
        'だ', 'ぢ', 'づ', 'で', 'ど',
        'ば', 'び', 'ぶ', 'べ', 'ぼ',
        'ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ'
    ];
    // ローマ字
    private static englishCharsList = [
        'a', 'i', 'u', 'e', 'o',
        'ka', 'ki', 'ku', 'ke', 'ko',
        'sa', 'shi', 'su', 'se', 'so',
        'ta', 'chi', 'tsu', 'te', 'to',
        'na', 'ni', 'nu', 'ne', 'no',
        'ha', 'hi', 'fu', 'he', 'ho',
        'ma', 'mi', 'mu', 'me', 'mo',
        'ya', 'yu', 'yo', '',
        'ra', 'ri', 'ru', 're', 'ro',
        'wa', 'wyi', 'wye', 'wo', 'n',
        'ga', 'gi', 'gu', 'ge', 'go',
        'za', 'ji', 'zu', 'ze', 'zo',
        'da', 'ji', 'du', 'de', 'do',
        'ba', 'bi', 'bu', 'be', 'bo',
        'pa', 'pi', 'pu', 'pe', 'po'
    ];

    /**
     * 複数置換リプレース関数
     * @param source 置換元
     * @param substitutions 置換文字配列
     */
    public static replaceArray(source: string, substitutions: any[]): string {
        // 置換文字配列分繰り返しreplaceを実行する。
        substitutions.forEach((val, key) => {
            source = source.replace('{' + key + '}', val);
        });
        return source;
    }

    /**
     * ファイル拡張子取得関数
     */
    public static getExtension(filename: string): string {
        const index = filename.lastIndexOf('.');
        if (index === -1) {
            return '';
        }
        return filename.slice(index + 1);
    }

    /**
    * 最大桁数チェック
    * @param inputLength 入力された桁数
    * @param maxLength 最大桁数
    * @param displayText エラーに表示する項目名
    * @returns string 異常値ならエラーメッセージ
    *          boolean 正常値ならtrue
    */
    public static checkLength(inputLength: string, maxLength: number, displayText: string): string | boolean {
        // 値が未入力なら正常値としてリターンする
        if (!inputLength) {
            return true;
        }

        // 最大桁数を超えているかチェック
        if (inputLength.length > maxLength) {
            return CommonFunction.replaceArray(MessageConst.E_MAX, [displayText, maxLength]);
        }

        return true;
    }

    /**
    * 桁数範囲チェック
    * @param inputLength 入力された文字列
    * @param minLength 最小桁数
    * @param maxLength 最大桁数
    * @param displayText エラーに表示する項目名
    * @returns string 異常値ならエラーメッセージ
    *          boolean 正常値ならtrue
    */
    public static checkLengthRange(inputLength: string, minLength: number, maxLength: number, displayText: string): string | boolean {
        // 値が未入力なら正常値としてリターンする
        if (!inputLength) {
            return true;
        }

        // 最小桁数に足りていないか、最大桁数を超えていないかチェック
        if (inputLength.length < minLength || inputLength.length > maxLength) {
            return CommonFunction.replaceArray(MessageConst.E_MIN_MAX, [displayText, minLength, maxLength]);
        }

        return true;
    }

    /**
     * ひらがなをローマ字に変換する関数
     * @param string kana 変換前ひらがな
     * @return string     変換後ローマ字
     */
    public static kanaEnglishChars(kana: string): string {
        const splitHiragana = [];
        // 引数を一文字ずつ分割
        for (let i = 0; i < kana.length; i++) {
            splitHiragana.push(kana[i]);
        }
        // 変換後文字列を配列として格納
        const splitEnglishChars: string[] = [];

        // 小文字があったか判断するパラメータ
        let lowerFlag = false;
        // 連続した小文字をカウントする変数
        let lowerCnt = 0;

        // 引数の文字数回繰り返す
        for (let i = kana.length - 1; i >= 0; i--) {
            // 小文字があった場合
            if (
                kana[i] === 'ぇ' ||
                kana[i] === 'ぃ' ||
                kana[i] === 'ゃ' ||
                kana[i] === 'ょ' ||
                kana[i] === 'ゅ' ||
                kana[i] === 'ぉ' ||
                kana[i] === 'ぁ' ||
                kana[i] === 'ぅ' ||
                kana[i] === 'ゎ'
            ) {
                // 小文字があった
                lowerFlag = true;
                lowerCnt++;

                // 連続した小文字があった場合
                if (lowerCnt === 2) {
                    // 1つ目の小文字の要素数を取得する
                    const index = this.onlyLowerList.indexOf(kana[i + 1]);

                    // 変換後配列の先頭に、連続した小文字の後ろから数えて1つ目の小文字をアルファベットに変換した文字を出力する
                    splitEnglishChars.unshift(this.englishOnlyLowerList[index]);
                    // 小文字カウンタを1減らす
                    lowerCnt--;
                }

                // 先頭の文字が小文字の場合
                if (i === 0) {
                    // 先頭の小文字を出力
                    const index = this.onlyLowerList.indexOf(kana[i]);

                    // 変換後配列の先頭に、変換前文字列の先頭にある小文字をアルファベットに変換した文字を格納する
                    splitEnglishChars.unshift(this.englishOnlyLowerList[index]);
                }
                continue;
            }

            // かなの中に「っ」を見つけた場合
            if (kana[i] === 'っ') {
                // 小文字の前に「っ」が入力された場合
                if (lowerCnt === 1) {
                    // 後ろ側の小文字を変換後配列に格納する
                    const index = this.onlyLowerList.indexOf(kana[i + 1]);
                    splitEnglishChars.unshift(this.englishOnlyLowerList[index]);

                    // 文字列の先頭に「っ」があった場合
                    if (i === 0) {
                        // 「xtu」に変換
                        const index = this.onlyLowerList.indexOf(kana[i]);
                        splitEnglishChars.unshift(this.englishOnlyLowerList[index]);
                    }
                    continue;
                }
                if (i === kana.length - 1 || kana[i + 1] === 'っ') {
                    // 文字列の最後尾にあった場合または、後ろの文字も「っ」であった場合
                    // 「xtu」に変換
                    const index = this.onlyLowerList.indexOf(kana[i]);
                    splitEnglishChars.unshift(this.englishOnlyLowerList[index]);
                    continue;
                }
                if (splitEnglishChars[0].indexOf('ch') === 0) {
                    // 「っ」の後ろの変換後文字の子音が「ch」になっている場合
                    // 「t」に変換
                    splitEnglishChars.unshift(splitHiragana[i].replace(kana[i], 't'));
                } else if (splitEnglishChars[0].length === 1) {
                    // 「っ」の後ろに書いてある文字が母音の場合
                    splitEnglishChars.unshift(splitEnglishChars[0]);
                } else if (splitEnglishChars[0].length === 3) {
                    // 「っ」の後ろの子音が「ch」以外の場合、後ろの子音に変換(例：「し」→「shi」)
                    splitEnglishChars.unshift(splitEnglishChars[0].substr(0, splitEnglishChars[0].length - 2));
                } else {
                    // 「っ」の後ろの子音が「ch」以外の場合、後ろの子音に変換(例：「さ」→「sa」)
                    splitEnglishChars.unshift(splitEnglishChars[0].substr(0, splitEnglishChars[0].length - 1));
                }

                lowerFlag = false;
                continue;
            }

            // 小文字カウンタを初期化
            lowerCnt = 0;

            if (lowerFlag) {
                // 小文字と結合して検索する
                const lowerKana = kana[i] + kana[i + 1];
                // 「きゃ」などの文字がどこにあるか検索
                const index = this.hiraganaLowerList.indexOf(lowerKana);
                if (index !== -1) {
                    // 検索に成功した場合
                    splitEnglishChars.unshift(this.englishCharsLowerList[index]);
                } else {
                    // 検索に失敗した場合（[あぁ]等）、小文字、大文字を別々に出力する
                    // 小文字の出力
                    const lowerIndex = this.onlyLowerList.indexOf(kana[i + 1]);

                    // 変換後配列の先頭に、連続した小文字の後ろから数えて1つ目の小文字をアルファベットに変換した文字を出力する
                    splitEnglishChars.unshift(this.englishOnlyLowerList[lowerIndex]);

                    // 大文字の出力
                    const uppercaseIndex = this.hiraganaList.indexOf(kana[i]);
                    splitEnglishChars.unshift(this.englishCharsList[uppercaseIndex]);
                }
            } else {
                // 「あ」などの文字を検索
                const index = this.hiraganaList.indexOf(kana[i]);
                splitEnglishChars.unshift(this.englishCharsList[index]);
            }
            lowerFlag = false;
        }
        // 変換後文字配列を結合する
        const englishChars = splitEnglishChars.join('');
        // 変換後の文字をreturnする
        return englishChars;
    }

    /**
     * 一覧画面の検索パラメータ作成
     * 
     * @param options ソート条件
     * @param filters フィルタ条件
     * @returns バック側へ渡すパラメータ
     * {
     *   'page': ページ番号
     *   'itemsPerPage': １ページあたりの行数
     *   'sortKey': ソートキー（v-data-tableの項目名)のカンマ区切り
     *   'sortOrder': ソート順('asc' or 'desc')
     *   'filterParams': {
     *                      '項目名1（v-data-tableの項目名)': {
     *                         'filterType': フィルタの種類('KeyWordPerfectMatch'等)
     *                         'filterValue': 検索値
     *                      },
     *                      '項目名2（v-data-tableの項目名)': {
     *                         'filterType': フィルタの種類('KeyWordPerfectMatch'等)
     *                         'filterValue': 検索値
     *                      }, ...
     *                   }
     *   }
     */
    public static makeListParameters(options: DataOptions, filters: TableFilters) {

        const params: { [key: string]: any } = {};
        const filterParams: { [key: string]: FilterApiValue } = {};

        // ページ情報
        if (options) {
            // 表示するページ番号
            params[SystemConst.LIST_API_PARAM.PAGE] = String(options.page);
            // １ページあたりの行数
            params[SystemConst.LIST_API_PARAM.ITEMS_PER_PAGE] = String(options.itemsPerPage);
            // ソートキー（v-data-tableのheadersに設定した'value'）
            params[SystemConst.LIST_API_PARAM.SORT_KEY] = options.sortBy.join(',');
            // ソート順（false => 'asc' true => 'desc'へ変換）
            params[SystemConst.LIST_API_PARAM.SORT_ORDER]
                = options.sortDesc.map(e => SystemConst.SORT_ORDER_MAPPING[Number(e)]).join(',');
        }

        // フィルタ条件
        //  以下の形式のJSONを作り、'filterParams'へ設定する。
        // {
        //     'ソート項目1': {
        //         'filterType': 'KeyWordPerfectMatch',
        //         'filterValue': 'フィルタ内容'
        //     },
        //     'ソート項目2': {
        //         'filterType': 'KeyWordPerfectMatch',
        //         'filterValue': 'フィルタ内容'
        //     }, ...
        // }
        //
        if (filters) {
            Object.keys(filters)
                .filter(key => filters[key].isEnabled)
                .forEach(key => {
                    const e = filters[key];

                    // 条件の種類によりパラメータの生成方法を変える
                    filterParams[e.id] = { filterType: e.types, filterValue: '' };
                    switch (e.types) {
                        // 文字列検索 パラメータ名=keyword
                        case 'KeyWordPerfectMatch':
                            filterParams[e.id].filterValue = e.condition.keyword;
                            break;
                        case 'KeyWordPartialMatch':
                            filterParams[e.id].filterValue = e.condition.keyword;
                            break;
                        // 範囲指定 パラメータ名=YYYY-MM-DD,YYYY-MM-DD
                        case 'DatePeriod':
                            filterParams[e.id].filterValue = String(e.condition.startDate || '') + ',' + String(e.condition.endDate || '');
                            break;
                        // 範囲指定 パラメータ名=X,X
                        case 'NumRange':
                            filterParams[e.id].filterValue = String(e.condition.minNumber || '') + ',' + String(e.condition.maxNumber || '');
                            break;
                        // 択一選択 パラメータ名=value
                        case 'PullDown':
                            filterParams[e.id].filterValue = e.condition.oneItem.value;
                            break;
                        // 複数選択 パラメータ名=value1,value2,...
                        case 'PullDownMulti':
                            filterParams[e.id].filterValue = e.condition.multiItem.map(v => v.value).join(',');
                            break;
                        // 複数選択 パラメータ名=value1,value2,...
                        case 'CheckBox':
                            filterParams[e.id].filterValue = e.condition.chkItems.filter(f => f.isChecked).map(chk => chk.value).join(',');
                            break;
                    }
                });
            params['filterParams'] = filterParams;
        }

        return params;
    }

    /**
     * Content-dispositionからファイル名を取得する
     * 
     * HTTPヘッダcontent-dispositionから、ファイル名を取得する。
     * filename= と filename*=がある場合、filename*=を取得する。
     * filename=のみの場合、filename=を取得する。
     * 
     * @param disposition content-dispositionの内容
     * @returns ファイル名
     */
    public static getFileNameFromContentDisposition(disposition: string) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g;
        const matches = disposition.match(filenameRegex);

        if (matches !== null) {
            if (matches[1]) {
                const fileName = decodeURI(matches[1].replace('filename=', '').replace('filename*=', '').replace(/['"]/g, '').replace('utf-8', ''));
                return fileName;
            } else {
                const fileName = decodeURI(matches[0].replace('filename=', '').replace('filename*=', '').replace(/['"]/g, '').replace('utf-8', ''));
                return fileName;
            }
        } else {
            // ファイル名が無い場合
            return '';
        }
    }

    /**
     * アカウント区分フィルタ（教職員・教職員（組織管理者））のパラメータ調整
     *
     * @param params makeListParametersで生成したパラメータオブジェクト
     * @param filters フィルタ情報
     */
    public static setOrgManagerFilterParams(params: any, filters: TableFilters) {
        // アカウント区分のフィルタに値が設定されていない場合は何もしない
        if (!filters['accountDivision']?.condition?.chkItems) {
            return;
        }

        // 「教職員（組織管理者）」、「教職員」それぞれのチェック状態を取得する
        const isOrganizationManagerChecked = filters['accountDivision'].condition.chkItems.some(
            (item: any) => item.value === SystemConst.ACCOUNT_DIVISION.TEACHER_ORGANIZATION_MANAGER && item.isChecked
        );
        const isTeacherChecked = filters['accountDivision'].condition.chkItems.some(
            (item: any) => item.value === SystemConst.ACCOUNT_DIVISION.TEACHER && item.isChecked
        );

        // 「教職員（組織管理者）」がチェックされていて、かつ「教職員」がチェックされていない場合
        if (isOrganizationManagerChecked && !isTeacherChecked) {
            params['filterParams']['isOrganizationManager'] = true;
        }

        // アカウント区分のフィルタの文字列に「教職員（組織管理者）」が含まれる場合
        if (params['filterParams']?.accountDivision?.filterValue?.includes(
            SystemConst.ACCOUNT_DIVISION.TEACHER_ORGANIZATION_MANAGER
        )) {
            // 「教職員（組織管理者）」を「a1」に変換する
            params['filterParams']['accountDivision']['filterValue'] =
                params['filterParams']['accountDivision']['filterValue'].replace(
                    SystemConst.ACCOUNT_DIVISION.TEACHER_ORGANIZATION_MANAGER,
                    SystemConst.ACCOUNT_DIVISION.TEACHER
                );
        }
    }
}
